import { Group } from '@/components/_common';
import { Moment } from 'moment';

interface Props {
  date: Moment;
}

const ReportDocumentSignature: React.FC<Props> = ({ date }) => {
  return (
    <div style={{ borderTop: '1px solid darkgray', paddingTop: 10 }}>
      <Group position="center">
        <span>Assinatura</span>
      </Group>
      <Group position="center">
        <span>{date.format('DD/MM/YYYY HH:mm')}</span>
      </Group>
    </div>
  );
};

export default ReportDocumentSignature;
